import React from 'react'
import { useLocation } from 'react-use'
import Header from './Header/Header'
import Footer from './Footer/Footer'

const Layout = ({ children }) => {
  const location = useLocation()
  const TransparentPages = []
  return (
    <>
      <Header fade={!TransparentPages.includes(location.pathname)} />
      {children}
      <Footer />
    </>
  )
}

export default Layout
